import React from "react";
import style from "./index.module.scss";
import { Button, Tooltip } from "antd";
import { BiUndo } from "react-icons/bi";
import { useHistory } from "react-router-dom";
import { TeaEvlProps } from "../../../../../../Service";

interface HeaderProps {
    data: TeaEvlProps;
}

export default function EvaluateHeader({ data }: HeaderProps) {
    const history = useHistory();
    return (
        <>
            {
                <div className={style.root}>
                    <div className={style.wrapper}>
                        <div className={style.left}>
                            <h1 className={style.title}>
                                <Tooltip
                                    title={data.name}
                                    placement="bottomLeft">
                                    <span>{data.name}</span>
                                </Tooltip>

                                <Button
                                    className={style.back}
                                    onClick={() => history.goBack()}>
                                    <BiUndo size={16} /> 返回
                                </Button>
                            </h1>

                            <div className={style.info}>
                                <span>{data.courseName}</span>
                                <span>{data.courseSeq}</span>
                                <span>{data.courseNo}</span>
                                <span>{data.teacherName}</span>
                                <span>评价截止时间 {data.endTime}</span>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}
